import { cn } from '@lib-atria/ui-toolkit';

export function AppointmentsCardDivider({ className }: { className?: string }) {
  return <div className={cn(className, 'border-t-2 max-w-4 border-product-sand-500 w-full')} />;
}
